import type { Props, Tracker } from "./tracker";

/**
 * Autocaptura de cliques (docs/SOLUCAO-TECNICA.md §7.4): sobe do alvo até o elemento com
 * `data-track` e repassa ao `resolve` do app, que traduz para o evento e as props.
 * Nunca lê valor de campo, texto digitado ou conteúdo da página: só atributos data-*.
 */
export type ClickResolver = (
  dataTrack: string,
  dataset: DOMStringMap,
) => { event: string; props?: Props } | null;

/** Padrão: o próprio data-track é o nome do evento, sem props. */
export const defaultResolver: ClickResolver = (dataTrack) => ({ event: dataTrack });

export function autoCapture(
  tracker: Tracker,
  resolve: ClickResolver = defaultResolver,
  root: Document | HTMLElement = document,
): () => void {
  const onClick = (e: Event) => {
    const target =
      e.target instanceof Element ? e.target.closest<HTMLElement>("[data-track]") : null;
    const dataTrack = target?.dataset["track"];
    if (!target || !dataTrack) return;
    const resolved = resolve(dataTrack, target.dataset);
    if (resolved) tracker.track(resolved.event, resolved.props);
  };
  // Captura: registra o clique mesmo se o elemento parar a propagação.
  root.addEventListener("click", onClick, { capture: true });
  return () => root.removeEventListener("click", onClick, { capture: true });
}
